export const enum MySkillsFiltersEnum {
  ALL = 'all',
  COMPLETED = 'completed',
  UNFINISHED = 'unfinished',
};
